/**
 * @flow
 */

import slugify from 'slugify';

slugify.extend({ æ: 'ae', ø: 'oe', å: 'aa' });

export default (string: string, directory?: string): string => {
  const filename = slugify(string); // + '.html';

  return directory ? `/${directory}/${filename}` : filename;
};
